import axios from 'axios'
import auth from '@/auth/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use((config) => {
  if (auth.isLogged()) {
    config.headers.Authorization = `Bearer ${auth.getTokenLogged()}`
  }
  return config
})

function assertResult (response) {
  const result = response && response.data ? response.data.result : null
  if (result !== 'OK' && result !== true) {
    throw new Error((response && response.data && response.data.message) || 'Operación no completada')
  }
}

function getErrorMessage (error, fallback = 'Operación no completada') {
  return (error && error.response && error.response.data && error.response.data.message) ||
    (error && error.message) ||
    fallback
}

function normalizeSecret (secret = {}) {
  return {
    ...secret,
    masked_value: secret.masked_value || '••••••••',
    has_stored_secret: Boolean(secret.has_stored_secret),
    person_id: secret.person_id || null,
    category: secret.category || 'General',
    username: secret.username || '',
    owner: secret.owner || '',
    needs_rotation: Boolean(secret.needs_rotation),
    updated_at: secret.updated_at || null,
    last_used_at: secret.last_used_at || null,
    secret: typeof secret.secret === 'string' ? secret.secret : ''
  }
}

export default {
  async getAccesses (companyId) {
    const response = await api.get('company/getSecrets', {
      params: { company_id: companyId }
    })

    const secrets = response && response.data && response.data.secrets ? response.data.secrets : []

    return {
      secrets: secrets.map(normalizeSecret)
    }
  },

  async getPersonAccesses (personId) {
    const response = await api.get('company/getSecrets', {
      params: { person_id: personId }
    })

    const secrets = response && response.data && response.data.secrets ? response.data.secrets : []

    return {
      secrets: secrets.map(normalizeSecret)
    }
  },

  async getSecret (secretId) {
    const response = await api.get('company/getSecret', {
      params: { secret_id: secretId }
    })
    return normalizeSecret(response.data.secret)
  },

  async revealSecret (secretId, action = 'reveal', reason = '', password = '') {
    try {
      const response = await api.post('company/revealSecret', {
        secret: {
          id: secretId,
          action,
          reason,
          password
        }
      })
      assertResult(response)
      return normalizeSecret(response.data.secret)
    } catch (error) {
      throw new Error(getErrorMessage(error, 'No fue posible revelar el acceso.'))
    }
  },

  async createSecret (payload) {
    const response = await api.post('company/createSecret', { secret: payload })
    assertResult(response)
    return normalizeSecret(response.data.secret || payload)
  },

  async updateSecret (payload) {
    try {
      const response = await api.post('company/updateSecret', { secret: payload })
      assertResult(response)
      return normalizeSecret(response.data.secret || payload)
    } catch (error) {
      const fallbackResponse = await api.post('company/createSecret', { secret: payload })
      assertResult(fallbackResponse)
      return normalizeSecret(fallbackResponse.data.secret || payload)
    }
  },

  async deleteSecret (secretId) {
    const response = await api.post('company/deleteSecret', { secret: { id: secretId } })
    assertResult(response)
    return true
  }
}
